import { render, staticRenderFns } from "./ConfigList.vue?vue&type=template&id=b09d4276&scoped=true&"
import script from "./ConfigList.vue?vue&type=script&lang=js&"
export * from "./ConfigList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigList.vue?vue&type=style&index=0&id=b09d4276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09d4276",
  null
  
)

export default component.exports